import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from 'spa/Components/ProgressiveImage';
import { withI18n } from 'spa/Components/Context';

const PlatformStoreLogos = ({
  ios,
  android,
  onClick,
  width,
  iosAlt,
  androidAlt,
}, { i18n }) => {
  function handleOnClick() {
    if (onClick) {
      onClick();
    }
  }

  return (
    <React.Fragment>
      {ios && (
        <div onClick={handleOnClick} data-testid="app-store-logo-wrapper">
          <ProgressiveImage
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_115/v1700149345/b2c-art/app-download-banners/apple-store-icon.png"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_230/v1700149345/b2c-art/app-download-banners/apple-store-icon.png"
            altText={iosAlt || i18n._x('Urban on the App Store', 'App Install Banner Login')}
            width={width || '115px'}
            height="auto"
          />
        </div>
      )}
      {android && (
        <div onClick={handleOnClick} data-testid="play-store-logo-wrapper">
          <ProgressiveImage
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_115/v1700149345/b2c-art/app-download-banners/play-store-icon.png"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_230/v1700149345/b2c-art/app-download-banners/play-store-icon.png"
            altText={androidAlt || i18n._x('Urban on the Google Play Store', 'App Install Banner Login')}
            width={width || '115px'}
            height="auto"
          />
        </div>
      )}
    </React.Fragment>
  );
};


PlatformStoreLogos.propTypes = {
  ios: PropTypes.bool,
  android: PropTypes.bool,
  onClick: PropTypes.func,
  width: PropTypes.string,
  iosAlt: PropTypes.string,
  androidAlt: PropTypes.string,
};

export default withI18n(PlatformStoreLogos);



// WEBPACK FOOTER //
// ./spa/Components/PlatformStoreLogos.jsx